import { render, staticRenderFns } from "./AppBarAdminMenu.vue?vue&type=template&id=96757b6a"
import script from "./AppBarAdminMenu.vue?vue&type=script&lang=js"
export * from "./AppBarAdminMenu.vue?vue&type=script&lang=js"
import style0 from "./AppBarAdminMenu.vue?vue&type=style&index=0&id=96757b6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports